export const STATE_TRANSITION_CHANGED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.DocumentStateTransitionChanged";
